import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthApi } from '@recargas-dominicanas/core/api';
import { type IAdmin } from '@recargas-dominicanas/core/types';
import { Title, Text, OutlineButton } from '@recargas-dominicanas/core/components';
import { useClickOutside } from '@recargas-dominicanas/core/hooks/useClickOutside';
import { style } from './user-profile.module.css';
import { CSSTransition } from 'react-transition-group';

interface Props {
  open: boolean;
  admin: IAdmin;
  onClose: () => void;
}

export function UserProfile(props: Props) {

  const {
    open,
    admin,
    onClose
  } = props;

  const navigate = useNavigate();

  const ref = useRef<HTMLDivElement>(null);

  useClickOutside(() => {
    onClose?.();
  }, ref, open, [onClose]);

  async function handleLogout() {
    await AuthApi.logout();
    onClose();
    navigate('/login');
  }

  return (
    <CSSTransition
      in={open}
      unmountOnExit={true}
      classNames={style.animation}
      timeout={150}
      nodeRef={ref}>
      <div 
        className={style.container}
        ref={ref}>
        <Title title={admin.name}/>
        <Text className={style.role} text='Administrador'/>
        <Text className={style.email} text={admin.email}/>
        <OutlineButton
          style={style.logoutButton} 
          icon='logout' 
          text='Cerrar sesión'
          onClick={handleLogout}/>
      </div>
    </CSSTransition>
  );
}
